/* eslint-disable eqeqeq */
import Vue from 'vue'
// 工具方法

// 通用组件
import Tag from '@/common/widgets/good_tag'

// 自定义组件
import SkuImg from './skuImg'
import SkuHeader from './skuHeader'
import GoodPrice from './goodPrice'
import SsuInfo from './ssuInfo'
import skuProduceSource from './skuProduceSource'
// import baseInfo from './widgets/base-info'
// import goodPrice from './widgets/new-good-price.vue'
// import goodPriceBillion from './widgets/new-good-price-billion.vue'
// import goodTag from './widgets/new-good-tag.vue'
// import goodShop from './widgets/good-shop'

// const STATUS_READY_SALE         = 0; //准备开售
// const STATUS_BUY                = 1; //购买
// const STATUS_CROSS_POINT        = 2; //已结束
// const STATUS_SELL_OUT           = 3; //已售罄
// const STATUS_ACTIVITY_NO_START  = 4; //活动未开始
// const STATUS_ACTIVITY_IS_END    = 5; //活动已结束
// const STATUS_OFFLINE            = 6; //下线
// const STATUS_LOOT_ALL           = 7; //已抢光
// const STATUS_HAVE_PARTICIPATE   = 8; //已参与
// const STATUS_SHOP_CLOSE         = 9; //店铺歇业

// eslint-disable-next-line import/no-default-export
export default Vue.extend({
  components: {
    SkuImg,
    Tag,
    SkuHeader,
    GoodPrice,
    SsuInfo,
    skuProduceSource
  },
  props: {
    sku: {
      type: Object,
      default: () => ({})
    },
    skuIndex: {
      type: Number,
      default: 0
    },
    imgWidth: {
      type: [Number, String],
      default: 136
    },
    reportModle: {
      type: String,
      default: ''
    },
    routerName: {
      type: String,
      default: ''
    },
    mapId: {
      type: String,
      default: ''
    },
    commonTracerParam: {
      type: Object,
      default: () => ({})
    },
    rank: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isMallAppMp() {
      return window.matrix?.isMiniProgram || window.matrix?.isMallApp
    },
    skuImg() {
      return this?.sku?.skuImg || {}
    },
    skuId() {
      return this?.sku?.skuBase?.skuId
    },
    bottomTag() {
      return this.sku?.skuImg?.bottomTag?.[0] || null
    },
    skuAllFormat() {
      return this.sku.skuFormats.skuAllFormat.filter(item => item)
    },
    ssuList() {
      return this.sku?.ssuList || []
    },
    remainTimeItem() {
      const tag = this.sku?.skuImg?.leftBottomTag?.find(
        t => t.remainTime !== undefined && t.remainTime !== null
      )
      return tag
    },
    remainTime() {
      const remainTime = this.remainTimeItem
        ? this.remainTimeItem.remainTime
        : 0
      return remainTime
    },
    showCountdown() {
      const showCountdown = this.remainTime > 0
      return showCountdown
    },
    remainTitle() {
      return this.remainTimeItem ? this.remainTimeItem.tag : ''
    },
    skuCommonTracerParams() {
      return Object.assign(
        {},
        {
          sku_id: this.skuId,
          sku_pos: this.skuIndex
        },
        this.commonTracerParam,
        this.sku.extraTrack ? this.sku.extraTrack : {}
      )
    }
  },
  methods: {
    // 统一商品模块埋点上报方法
    tracerReport(spm = '', params = {}) {
      this.$track(spm, Object.assign({}, this.skuCommonTracerParams, params))
    },
    goDetailTrack(params) {
      if (this.reportModle) {
        const spm = this.$trackMap[this.reportModle].goodMin
        if (spm) {
          this.tracerReport(spm, params)
        }
      }
    },
    addCartTrack() {
      if (this.reportModle) {
        const spm = this.$trackMap[this.reportModle].goodAdd
        if (spm) {
          this.tracerReport(spm)
        }
      }
    },
    minCartTrack() {
      if (this.reportModle) {
        const spm = this.$trackMap[this.reportModle].miniCart
        if (spm) {
          this.tracerReport(spm)
        }
      }
    },
    formateOpenTrack(open) {
      if (this.reportModle) {
        const spm = open
          ? this.$trackMap[this.reportModle].chooseFormate
          : this.$trackMap[this.reportModle].chooseFormateClose
        if (spm) {
          this.tracerReport(spm)
        }
      }
    }
  }
})
